module.exports = __webpack_public_path__ + "img/chest_open.713de0d4.jpeg";